import { render, staticRenderFns } from "./PreMessageCard.vue?vue&type=template&id=d57c447e&scoped=true&"
import script from "./PreMessageCard.vue?vue&type=script&lang=js&"
export * from "./PreMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./PreMessageCard.vue?vue&type=style&index=0&id=d57c447e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57c447e",
  null
  
)

export default component.exports